/**
 * @file This is the main project file where all other scripts should be initiated.
 *
 * Note that since this file will be appended to the `body` element there is no need
 * to wait for the DOMContentLoaded event before initiating your scripts. In fact, it
 * will not work since the DOMContentLoaded event will have been triggered before this
 * file is loaded. Instead use an iife (1) or, as in the example below, a function
 * that is called when a custom event is triggered.
 *
 * 1. https://en.wikipedia.org/wiki/Immediately-invoked_function_expression
 *
 * Examples
 *
 * Load a self-initiating script that does not expect a DOMContentLoaded event:
 * import './path/to/script.js'
 *
 * Load a script that you need to send parameters to or initiate at a specific time:
 * First import the script:
 * import functionName from './path/to/script.js'
 * Note that the path needs to start with './' and be relative to your code root, which
 * is 'project' by default.
 * Then initiate it:
 * functionName(param);
 *
 * See the included examples for more.
 */

import scrollableElement from './components/scrollable-element/c-scrollable-element.js';
import ThumbSlider from './components/form-elements/thumb-slider/c-thumb-slider.js';

// import './js/vendor/polyfills/polyfill-custom-event.js';
import uploadFile from './components/form-elements/file-upload/c-file-upload.js';
import stickySidebar from './components/navigation/side-navigation/c-side-navigation.js';
import preventScroll from './components/navigation/navigation-mobile/c-navigation-mobile.js';
import copyToClipboard from './components/form-elements/copy-to-clipboard/c-copy-to-clipboard.js';
import ResponsiveTable from './components/responsive-table/c-responsive-table.js';
import reminder from './components/reminder/c-reminder.js';
import truncate from './components/truncate/c-truncate.js';

document.addEventListener('newcontent', (e) => {
	let context = e.target;

	// 	// Make tables scrollable if needed
	scrollableElement(context.querySelectorAll('table:not(.not-scrollable)'));
});

// Target all tables with a specific class name
document.querySelectorAll('.c-responsive-table').forEach(table => new ResponsiveTable({
	element: table
}));

document.dispatchEvent(new CustomEvent('newcontent'));

// Init thumb slider
(function () {
	let slider = document.querySelectorAll('.c-thumb-slider');
	for (let i = 0; i < slider.length; i++) {
		new ThumbSlider(slider[i]);
	}
})();

// init stickysidebar
stickySidebar();

// Init upload file
uploadFile();

// Init preventScroll function
preventScroll();

// Init copyToClipboard
copyToClipboard();

// Init reminder
reminder();

// Init truncate
truncate();